(function () {
  if (window.__ppBtt) return;
  window.__ppBtt = true;
  var btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'pp-btt';
  btn.setAttribute('aria-label', 'Retour en haut de page');
  btn.innerHTML = '<svg class="pp-btt__arrow" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg><span>Haut de page</span>';
  document.body.appendChild(btn);

  // Visible dès que le défilement dépasse le seuil réglable (réglage thème pp_btt_threshold, 150 px par défaut).
  function update() {
    var t = Number(window.ppBttThreshold);
    if (!isFinite(t) || t < 0) t = 150;
    btn.classList.toggle('is-visible', window.scrollY > t);
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);

  btn.addEventListener('click', function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    var target = document.querySelector('header a, header button, .header a');
    if (target) {
      setTimeout(function () { try { target.focus({ preventScroll: true }); } catch (e) {} }, reduce ? 0 : 600);
    }
  });
  update();
})();
